// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C2VE","questions":"styles_questions__1ISUO","footer":"styles_footer__3_tPt"};